import styles from "./social-network-links.module.css";
import {FaFacebookSquare, FaPinterestP, FaYoutube} from "react-icons/fa";
import {FaXTwitter} from "react-icons/fa6";

export default function SocialNetworkLinks() {
    return (
        <div className={styles['social-icons']}>
            <a className={styles.socialLink} rel="noopener noreferrer" target="_blank" href="https://www.facebook.com/UltraXDiagnostics">
                <FaFacebookSquare />
                <br />
                Facebook
            </a>
            <a className={styles.socialLink} rel="noopener noreferrer" target="_blank" href="https://www.pinterest.com/ultraxinc/">
                <FaPinterestP />
                <br />
                Pinterest
            </a>
            <a className={styles.socialLink} rel="noopener noreferrer" target="_blank" href="https://x.com/ultra_x_inc">
                <FaXTwitter />
                <br />
                X
            </a>
            <a className={styles.socialLink} rel="noopener noreferrer" target="_blank" href="https://www.youtube.com/user/pcdiag">
                <FaYoutube />
                <br />
                YouTube
            </a>
        </div>
    )
}
